module.exports = __webpack_public_path__ + "img/product-5.1c393cbd.jpg";